import { isAxiosError } from 'axios';

export function formatError2ErrorInfo(error: any) {
  if (isAxiosError(error)) {
    return {
      name: error.name,
      message: error.message,
      code: error.code,
      status: error.response?.status,
      responseData: error.response?.data,
      method: error.config?.method?.toUpperCase(),
      url: error.config?.url,
      params: error.config?.params,
      requestData: error.config?.data,
      stack: error.stack,
    };
  }

  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }

  if (typeof error === 'object' && error !== null) {
    return {
      name: 'UnknownErrorObject',
      message: JSON.stringify(error),
    };
  }

  return {
    name: 'NonObjectError',
    message: String(error),
  };
}

export const isAbortError = (errorInfo: { message?: string; name?: string }): boolean => {
  const keyword = 'abort';
  const msgMatch = errorInfo.message?.toLowerCase().includes(keyword) ?? false;
  const nameMatch = errorInfo.name?.toLowerCase().includes(keyword) ?? false;

  return msgMatch || nameMatch;
};
